<template>
  <div class="mini-tab">
    <ModalHowToUseCSV
      :isShowModal="isHowToUseCSVModal"
      @cancel="changeHowToUseCSVModal"/>
    <div class="mini-menu">
      <b-upload v-model="csvFile"
        accept=".csv">
        <a class="button is-small">
          <span>変数一覧をCSVインポート</span>
        </a>
      </b-upload>
      <button @click="csvFileExport()" class="button is-small -left-8px">
        変数一覧をCSVエクスポート
      </button>
      <QuestionButton
        @click.native="changeHowToUseCSVModal(true)"
        class="-left-8px"
        width ="30px"
        height="30px"/>
    </div>
    <div class="mini-menu">
      <input placeholder="変数名（先頭と末尾に$を付与してください）" class="input is-small" v-model="minibotvarName"/>
      <select class="select vat-select" v-model="varTypeInput">
        <option v-for="(t, idxType) in varType" :key="idxType" :value="idxType">
          {{t}}
        </option>
      </select>
      <button class="button is-primary is-small select-btn" @click="createChatBotMiniVariableGroup(currentRobo)">共通変数を作成する</button>
    </div>
    <div class="mini-menu">
      <input placeholder="🔍ミニロボ名検索" class="input is-small" v-model="searchMvarWord"/>
    </div>
    <span v-if="isLoading || csvFile" class="mdi mdi-loading mdi-spin mdi-48px"></span>
    <div class="mini-body" v-if="!isLoading && !csvFile">
      <b-collapse v-for="(mini, idx) in searchMvar(currentMiniRobo)"
        :key="idx"
        class="card"
        animation="slide"
      >
        <div
          slot="trigger"
          slot-scope="props"
          class="card-header"
          role="button">
          <div class="card-header-title">
            <span class="idx">{{idx + 1}}.</span>
            <div class="image-wrapper">
              <img style="cursor: pointer; width: 48px; height: 48px; border-radius: 50%; object-fit: cover; background: white;" class="image" :src="mini.icon_data" v-if="mini.icon_data"/>
              <img style="cursor: pointer; width: 48px; height: 48px; border-radius: 50%; object-fit: cover; background: white;" class="image" src="@/assets/template/robot.png" v-else>
            </div>
            <span class="mini-name">{{mini.name}}</span>
            <span class="card-header-title-span">の変数一覧</span>
          </div>
          <a class="card-header-icon">
              <b-icon
                  :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
          </a>
        </div>
        <div class="card-content">
            <div class="mini-table-wrapper">
              <table class="mini-table" style="overflow-y: scroll; will-change: transform;">
                <tr class="mini-header">
                  <th style="min-width: 64px; max-width: 64px;">項番</th>
                  <th style="min-width: 120px; max-width: 120px;">変数</th>
                  <th style="min-width: 90px; max-width: 90px;">タイプ</th>
                  <th style="min-width: 190px; max-width: 190px;">データ</th>
                  <th style="min-width: 60px; max-width: 60px;">保存</th>
                  <th style="min-width: 60px; max-width: 60px;">削除</th>
                </tr>
                <tr class="mini-table-body" v-for="(mvar, index) in mini.chatbot_mini_var" :key="index">
                  <td style="min-width: 64px; max-width: 64px;">
                    {{index + 1}}
                  </td>
                  <td style="text-align: left; min-width: 120px; max-width: 120px; word-wrap: break-word;">
                    {{mvar.variable_name}}
                  </td>
                  <td style="text-align: left; min-width: 90px; max-width: 90px;">
                    {{mvar.type === 0 ? '文言' : '日程調整'}}
                  </td>
                  <td style="text-align: left; min-width: 190px; max-width: 190px;">
                    <template v-if="mvar.type === 0">
                      <textarea class="input is-small table-input"
                        style="resize: none;"
                        :style="flexibleRows(mvar.variable_data, 3)"
                        wrap="off"
                        @change="updateChatBotMiniVariableGroup(mvar)"
                        @focus="onFocus"
                        @blur="onBlur"
                        v-model="mvar.variable_data">
                      </textarea>
                    </template>
                    <template v-else>
                      <button class="button is-small is-fullwidth" @click="setModalFooterVar(mvar)">選択</button>
                    </template>
                  </td>
                  <td style="min-width: 60px; max-width: 60px;">
                    <button class="button is-small is-primary" @click="updateChatBotMiniVariableGroup(mvar)">保存</button>
                  </td>
                  <td style="min-width: 60px; max-width: 60px;">
                    <button class="button is-small is-danger" @click="deleteChatBotMiniVariableGroup(mvar.pk)">削除</button>
                  </td>
                </tr>
              </table>
            </div>
        </div>
      </b-collapse>
    </div>
    <div v-if="chatbot.chatbot_mini.length == 0" style="text-align: center; margin-top: 8px;">
      ミニロボが設定されていません。
    </div>
  </div>
</template>

<script>
import Encoding         from 'encoding-japanese'
import getNewLineCode   from '@/functions/getNewLineCode'
import QuestionButton   from '@/components/atoms/buttons/QuestionButton'
import ModalHowToUseCSV from '@/components/ChatBot/organisms/ModalHowToUseCSV'
import controlLogMixin  from '@/mixins/controlLogMixin'
import alterReplace     from '@/functions/alterStrReplace'
export default {
  props: {
    chatbot: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    QuestionButton,
    ModalHowToUseCSV
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      minibotvarName: null,
      searchMvarWord: '',
      varType: [
        '文言',
        '日程調整',
      ],
      varTypeInput: 0,
      csvFile: null,
      isHowToUseCSVModal: false,
      localRoboData: null,
      isForcus: false,
      isEdit: false
    }
  },
  created () {
    // リアクティブに反応しないのでローカル変数に退避する
    this.localRoboData = JSON.parse(JSON.stringify(this.chatbot))
    // 変数データのエスケープされている「,」と「|」を元に戻す
    this.alterDecode()
  },
  computed: {
    currentRobo () {
      // ミニロボ変数を追加または削除したときに、ミニロボ変数の増減分を反映
      this.localRoboData = JSON.parse(JSON.stringify(this.chatbot))
      // 「,」と「|」を元に戻す
      this.alterDecode()
      return this.localRoboData
    },
    currentMiniRobo () {
      // キー入力のたびに呼ばれるので、フォーカスインしているときは処理しない
      if (this.isForcus === false) {
        // フォーカスアウトしていて、編集中ではないときだけ処理する
        if (this.isEdit === false) {
          this.localRoboData = JSON.parse(JSON.stringify(this.chatbot))
          // 「,」と「|」を元に戻す
          this.alterDecode()
        }
        // 次にcurrentMiniRoboが呼ばれたときにthis.chatbotを更新するようにthis.isEditをfalseにする
        this.isEdit = false
      }
      return this.localRoboData.chatbot_mini
    }
  },
  watch: {
    csvFile () {
      if (this.csvFile) {
        this.csvFileImport()
      }
    },
  },
  methods: {
    onFocus () {
      // ミニロボ変数データ入力中
      this.isForcus = true
      // フォーカスインした時点で編集中扱いにする
      this.isEdit = true
    },
    onBlur () {
      // ミニロボ変数データからフォーカスアウト
      this.isForcus = false
    },
    createChatBotMiniVariableGroup (chatbot) {
      this.sendControlLogRelatedChatBot('ミニロボ変数作成', 'ミニロボ設定画面にて、共通変数を新規に作成した。', chatbot)
      this.$emit('create-chatbot-mini-variable-group', {
        chatbot: chatbot,
        name: this.minibotvarName,
        varTypeInput: this.varTypeInput
      })
      this.minibotvarName = null
      this.varTypeInput = 0
    },
    updateChatBotMiniVariableGroup (data) {
      this.sendControlLogRelatedChatBot('ミニロボ変数編集', 'ミニロボ設定画面にて、共通変数を編集した。', this.chatbot)
      this.$emit('update-chatbot-mini-variable-group', data)
    },
    deleteChatBotMiniVariableGroup (pk) {
      this.sendControlLogRelatedChatBot('ミニロボ変数削除', 'ミニロボ設定画面にて、共通変数を削除した。', this.chatbot)
      this.$emit('delete-chatbot-mini-variable-group', pk)
      // ミニロボ変数データを編集した後にミニロボ変数削除を削除すると
      // currentMiniRobo()またはcurrentRobo()が呼ばれないので、this.chatbotを反映すると呼ばれる
      this.localRoboData = JSON.parse(JSON.stringify(this.chatbot))
    },
    setModalFooterVar (data) {
      this.$emit('set-modal-footer-var', data)
    },
    searchMvar (mini) {
      if (this.searchMvarWord === '') {
        return mini
      } else {
        let obj = []
        for (const m of mini) {
          if (~m.name.toLowerCase().indexOf(this.searchMvarWord.toLowerCase())) obj.push(m)
        }
        return obj
      }
    },
    flexibleRows (str, max_rows) {
      if (str) {
        let count_lf = (str.match(/\n/g) || []).length
        let rows = Math.min(count_lf+1, max_rows)
        return {
          // 変数データの改行数に合わせる
          'line-height': '1.5em',
          'height': (rows*1.5+1) + 'em'
        }
      } else {
        // 変数データが空欄の場合はデフォルトで2.5em
        return {
          'line-height': '1.5em',
          'height': '2.5em'
        }
      }
    },
    csvFileExport () {
      this.sendControlLogRelatedChatBot('ミニロボ変数CSVエクスポート', 'ミニロボ設定画面にて、CSVで変数一覧をエクスポートした。', this.chatbot)
      this.$store.dispatch('chatbot/exportChatBotMiniVariableGroup', {
        chatbot_id: this.localRoboData.bot_id
      }).then((csv_str) => {
        let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        let blob = new Blob([
          bom,
          csv_str
        ], {'type': 'text/csv'})
        let el = document.createElement('A')
        el.download = 'ミニロボデータ.csv'
        el.href = window.URL.createObjectURL(blob)
        document.body.appendChild(el)
        el.click()
        document.body.removeChild(el)
      })
    },
    csvFileImport () {
      this.sendControlLogRelatedChatBot('ミニロボ変数CSVインポート', 'ミニロボ設定画面にて、CSVで変数一覧をインポートした。', this.chatbot)
      let reader = new FileReader()
      reader.onload = (e) => {
        const res = new Uint8Array(e.target.result)
        const encoding = Encoding.detect(res)
        const data = Encoding.convert(res, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        })
        this.$store.dispatch('chatbot/importChatBotMiniVariableGroup', {
          chatbot: this.localRoboData,
          import_data: data
        }).then((robo) => {
          this.csvFile = null
          this.localRoboData = robo
          // 変数データのエスケープされている「,」と「|」を元に戻す
          this.alterDecode()
        })
      }
      reader.readAsArrayBuffer(this.csvFile)
    },
    changeHowToUseCSVModal (flg) {
      this.isHowToUseCSVModal = flg
    },
    alterDecode () {
      for (let minirobo of this.localRoboData.chatbot_mini) {
        for (let miniVar of minirobo.chatbot_mini_var) {
          // 変数データのエスケープされている「,」と「|」を元に戻す
          miniVar.variable_data = alterReplace(miniVar.variable_data, true)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-tab {
  padding-top: 16px;
  .mini-menu {
    display: flex;
    margin: 8px;
    input {
      border-radius: 0;
    }
    .vat-select {
      height: 30.5px;
      border: 0;
      outline: 1px solid #ccc;
      outline-offset: -1px;
    }
    .select-btn {
      min-width: 150px;
    }
  }
  .mini-body {
    overflow-y: scroll;
    .mini-table-wrapper {
      width: 100%;
      .mini-table {
        will-change: transform;
        margin: auto;
        .mini-header {
          display: table;
          th {
            padding: 4px;
            vertical-align: middle;
            text-align: center;
          }
        }
        .mini-table-body {
          display: table;
          text-align: center;
          max-height: 50px;
          min-height: 50px;
          height: 50px;
          td {
            padding: 4px;
            vertical-align: middle;
            text-align: center;
            input, button {
              margin: auto;
            }
            .table-input {
              border: dotted thin #ccc;
              background: transparent;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/MiniSettingVar.vue